export function isPageLoadError(error: Error | null): boolean {
  return !!error && /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk .+ failed|Unable to preload CSS/i.test(error.message);
}

export function recoverPageLoad(error: Error): void {
  if (!isPageLoadError(error) || !navigator.onLine) return;
  // A deploy or interrupted download can invalidate a lazy module. Reload
  // once to get the current entrypoint, keeping the route and saved replay.
  // Never loop if the connection/server remains unavailable.
  try {
    const key = 'f1-page-load-recovery';
    const previous = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - previous < 60_000) return;
    sessionStorage.setItem(key, String(Date.now()));
    window.location.reload();
  } catch { /* Storage unavailable: keep the explicit retry button. */ }
}
